import { useThreadFileGetURLQueryLazyQuery } from 'graphql/generated'
import { useCallback } from 'react'

function useConvertS3KeysToImageUrl(discussionBoardId: string) {
  const [getFileUrl] = useThreadFileGetURLQueryLazyQuery({
    fetchPolicy: 'network-only'
  })
  const updateUrls = useCallback(
    async (newBody: string) => {
      try {
        const regex = /.*?(\[\[s3Key:(.*?)\]\]).*?/g
        let match = regex.exec(newBody)
        while (match != null) {
          const resp = await getFileUrl({
            variables: {
              discussionBoardId,
              key: match[2]
            }
          })
          if (resp.data?.threadFileGetUrl) {
            newBody = newBody.replace(
              match[1],
              `<img src="${resp.data?.threadFileGetUrl.url}">`
            )
          }
          match = regex.exec(newBody)
        }

        return newBody
      } catch (e) {
        return newBody
      }
    },
    [discussionBoardId, getFileUrl]
  )

  return updateUrls
}
export default useConvertS3KeysToImageUrl
